/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useSearchParams } from 'react-router-dom';
import '../blog/blog.scss';
import PageHeader from '../../layouts/page-header/PageHeader';
import Pagination from '../../component/pagination';
import { cutLetter } from '../../utils';
import Loading from '../../component/Loading';
import { HiOutlineEye } from 'react-icons/hi2';
import { bilimMerkezAPI } from '../../api';

const Announcements = () => {
  const [data, setData] = useState([]);
  const { t, i18n } = useTranslation();
  const language = i18n.language;
  const lang = language === 'tk' ? 'tm' : language;

  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);

  // get current page from URL
  const [searchParams, setSearchParams] = useSearchParams();
  const currentPage = parseInt(searchParams.get('page')) || 1;

  const handlePageChange = (pageNumber) => {
    setSearchParams({ page: pageNumber });
  };

  const limit = 20;
  const offset = (currentPage - 1) * limit;

  useEffect(() => {
    window.scrollTo(0, 0);
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await bilimMerkezAPI.get(`/notices`, {
          params: {
            lang,
            limit,
            offset,
          },
        });
        setData(res.data?.results || []);
        setCount(res.data?.count || 0);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [lang, currentPage]);

  const getLocalizedTitle = (item) => {
    switch (lang) {
      case 'tm':
        return item.title_tm;
      case 'ru':
        return item.title_ru;
      case 'en':
        return item.title_en;
      case 'ko':
        return item.title_ko;
      default:
        return item.title_tm;
    }
  };

  return (
    <div className="site-content">
      <PageHeader
        colSize="col-md-10"
        title={t('announcements')}
        PagaHeaderBg="/images/bg.svg"
        breadCrumbItems={[{ label: t('home'), path: '/' }]}
      />

      <div className="event-ara page-template content-wrapper">
        <div className="container">
          {loading ? (
            <div
              style={{
                width: '100%',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Loading style={{ width: '10%' }} />
            </div>
          ) : (
            <div className="row">
              <div className="col-sm-12">
                <div className="grid-wrapper grid-lg-2 grid-md-1">
                  {data.length > 0 &&
                    data.map((item) => (
                      <Link
                        to={`/announcement-details/${item?.slug || ''}`}
                        key={item.id}
                        className="single-item"
                      >
                        <div className="single-item-content relative">
                          <div className="event_date f-left">
                            <div className="event_date_inner">
                              {item.image && (
                                <img
                                  className="img"
                                  src={item.image}
                                  alt={getLocalizedTitle(item)}
                                />
                              )}
                            </div>
                          </div>
                          <div className="event_info">
                            <h3>
                              {cutLetter({
                                letter: getLocalizedTitle(item),
                                maxSize: 70,
                              })}
                            </h3>
                            <p className="view_count">
                              <HiOutlineEye size={22} /> {item.views ?? 0}
                            </p>
                          </div>
                        </div>
                      </Link>
                    ))}
                </div>
              </div>
            </div>
          )}
        </div>

        <Pagination
          currentPage={currentPage}
          count={count}
          limit={limit}
          handlePageChange={handlePageChange}
        />
      </div>
    </div>
  );
};

export default Announcements;
